import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  TableRow,
  TablePagination,
  TableSortLabel ,
  Typography,
  IconButton,
  Paper
} from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort } from '@fortawesome/free-solid-svg-icons'

import CssBaseline from '@material-ui/core/CssBaseline';
import { useSelector } from "react-redux";
import axios from "axios";
import envConfig from "../../bin/env.config";
import ButtonEdit from "./Projects/ButtonEdit";
import ButtonSummary from "./Projects/ButtonSummary";
import ButtonSelectBanners from "./Projects/ButtonSelectBanners";
import ButtonSelectCities from "./Projects/ButtonSelectCities";
import ButtonDelete from "./Projects/ButtonDelete";
import ButtonSync from "./Projects/ButtonSync";
import ProductsCount from "./Projects/ProductsCount";
import {
  projectTypes,
  useProjectTypeStyles,
  getProjectTypeLabel,
  getProjectTypeStyle,
  getMenuItemStyle,
  getDotStyle
} from "./Projects/ProjectTypeConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  table: {
    minWidth: 350,
    "& tbody>.MuiTableRow-root:hover": {
      background: "#DDD",
    },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  searchField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
  },
  filterField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    minWidth: 200,
  },
  sortLabel: {
    cursor: "pointer",
  },
  projectName: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export function SortLabel(props){
  const classes = useStyles();
  return (
    <TableSortLabel 
                {...props}
                className={classes.sortLabel}
                IconComponent={props=>(props.hideSortIcon?'':<FontAwesomeIcon icon={faSort} />)}
              >
                {props.noWrap?(<span style={{paddingRight:'5px',whiteSpace:'nowrap'}}>{props.children}</span>):
                (<span style={{paddingRight:'5px'}}>{props.children}</span>)}               
                </TableSortLabel>
  )
}
export default function CompanyReportToolPage() {
  const history = useHistory();
  const classes = useStyles();
  const projectTypeClasses = useProjectTypeStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name")
  const [filter, setFilter]=useState({q:''})
  const [dataSource, setDataSource] = useState([]);
  const [reloadData, setReloadData] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [projectType, setProjectType] = useState("all");
  const [totalCount, setTotalCount] = useState(0);

  const token = useSelector((state) => state.session.token);
  
  const loader = document.querySelector(".loader");
  const showLoader = () => loader.classList.remove("loader--hide");

  const hideLoader = () => {
    loader.classList.add("loader--hide");
    // updateContainer.classList.add("loader--hide");
  };
  const doReloadData =()=>{setReloadData(reloadData+1)}

  useEffect(() => {
    
    const fetchData = async () => {
      showLoader();
      setIsLoading(true);
      const skip = page * rowsPerPage;
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/projects?orderBy=${orderBy}&order=${order}&limit=${rowsPerPage}&skip=${skip}`;
      const result = await axios.post(url,filter, {
        headers: {
          Authorization: token,
        },
      });
      setDataSource(result.data.data);
      if (result.data.total !== undefined) {
        setTotalCount(result.data.total);
      } else if (result.data.count !== undefined) {
        setTotalCount(result.data.count);
      } else {
        setTotalCount(result.data.data.length < rowsPerPage ? (page * rowsPerPage + result.data.data.length) : (page + 1) * rowsPerPage + 1);
      }
      setIsLoading(false);
      hideLoader();
    };
    fetchData();
  
}, [filter, page, rowsPerPage, order, orderBy, reloadData, token]);
const handleSort=(column)=>{
  setOrder(order==='desc'?'asc':'desc');
  setOrderBy(column);
  setPage(0);
}

const handleSearchChange = (event) => {
  setSearchQuery(event.target.value);
  setFilter({ ...filter, q: event.target.value });
  setPage(0);
};

const handleProjectTypeChange = (event) => {
  const newType = event.target.value;
  setProjectType(newType);
  setFilter({ ...filter, projectType: newType === "all" ? "" : newType });
  setPage(0);
};

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};

const handlePageSelect = (event) => {
  setPage(parseInt(event.target.value, 10));
};

  return (
    <>
     {/* <CssBaseline /> */}
      <AppBar position="sticky" color="inherit">
        <Toolbar>
          {/* <IconButton
            color="inherit"
            onClick={() => history.goBack()}
            aria-label="Close"
          >
            <ArrowBackIcon />
          </IconButton> */}
          <Typography className={classes.title} variant="h6" noWrap>
            Customer & Report Tool
          </Typography>   
          <TextField
            className={classes.searchField}
            placeholder="Search by ID or Name..."
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <FormControl className={classes.filterField}>
            <Select
              labelId="project-type-label"
              value={projectType}
              onChange={handleProjectTypeChange}
              label="Project Type"
            >
              {projectTypes.map((type) => (
                <MenuItem 
                  key={type.value} 
                  value={type.value}
                  className={`${projectTypeClasses.menuItem} ${getMenuItemStyle(projectTypeClasses, type.value)}`}
                >
                  <div className={`${projectTypeClasses.menuItemDot} ${getDotStyle(projectTypeClasses, type.value)}`} />
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <ButtonEdit reloadData={doReloadData}/>       
        </Toolbar>
      </AppBar>
      {isLoading ? (
        <Grid
          className={classes.root}
          container
          alignItems="center"
          justifyContent="center"
        >
          <div>Loading ...</div>
        </Grid>
      ) : (
        <Grid
        className={classes.root}
        container
        alignItems="center"
        justifyContent="center"
      >
        <TableContainer component={Paper}>
          <Table className={classes.table} stickyHeader aria-label="simple table">
            <TableHead >
              <TableRow>
                <TableCell colSpan={6} align="center" style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '8px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Typography variant="body2" style={{ whiteSpace: 'nowrap' }}>
                        Go to page:
                      </Typography>
                      <Select
                        value={page}
                        onChange={handlePageSelect}
                        style={{ minWidth: '80px' }}
                        size="small"
                        disabled={totalCount === 0 || Math.ceil(totalCount / rowsPerPage) === 0}
                      >
                        {Array.from({ length: Math.ceil(totalCount / rowsPerPage) }, (_, i) => (
                          <MenuItem key={i} value={i}>
                            {i + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <TablePagination
                      component="div"
                      count={totalCount}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[10, 20, 50, 100]}
                    />
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                {/* <TableCell align="center">data_year_week</TableCell> */}
                <TableCell align="left" width={'200px'}>
                  Command                
                </TableCell>
                <TableCell align="left">
                  ID                
                </TableCell>
                <TableCell align="left" >                    
                  <SortLabel onClick={()=>handleSort('name')}>Name</SortLabel>
                </TableCell>
                <TableCell align="left"  style={{whiteSpace:'nowrap'}}>
                  # Products                
                </TableCell>
                <TableCell align="left"  style={{whiteSpace:'nowrap'}}>
                  Last Updated                
                </TableCell>
                <TableCell align="left">
                  Config                
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataSource.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell align="left">
                      <ButtonDelete project={row} reloadData={doReloadData}/> 
                      <ButtonEdit project={row} reloadData={doReloadData}/> 
                      <ButtonSummary project={row} />
                      <ButtonSync project={row}/> 
                      <IconButton
                        color="primary"
                        component={Link}
                        to={`/company-report-tool-product-tree/${row.id}`}
                        title="Products tree view"
                        aria-label="Products tree view"
                      >
                        <AccountTreeIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell align="left">
                      {row.id}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        to={`/company-report-tool-product/${row.id}`}
                        className={classes.projectName}
                      >
                        {row.name}
                      </Link>
                      <div>
                        <span className={getProjectTypeStyle(projectTypeClasses, row.project_type)}>
                          {getProjectTypeLabel(row.project_type)}
                        </span>
                        {' - '}
                        {row.description}
                      </div>
                    </TableCell>
                    <TableCell align="left">
                      <ProductsCount projectId={row.id}/>
                    </TableCell>
                    <TableCell align="left">{row.updated_at}</TableCell>
                    <TableCell align="left">
                      <ButtonSelectBanners project={row} />
                      <ButtonSelectCities project={row} />
                    </TableCell>
                  </TableRow>                  
                
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={6} align="center" style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '8px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Typography variant="body2" style={{ whiteSpace: 'nowrap' }}>
                        Go to page:
                      </Typography>
                      <Select
                        value={page}
                        onChange={handlePageSelect}
                        style={{ minWidth: '80px' }}
                        size="small"
                        disabled={totalCount === 0 || Math.ceil(totalCount / rowsPerPage) === 0}
                      >
                        {Array.from({ length: Math.ceil(totalCount / rowsPerPage) }, (_, i) => (
                          <MenuItem key={i} value={i}>
                            {i + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <TablePagination
                      component="div"
                      count={totalCount}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[10, 20, 50, 100]}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>             
          </Table>
        </TableContainer>
      </Grid>
      )}
    </>
  );
}
